import { render, staticRenderFns } from "./mDevplatform.vue?vue&type=template&id=6b61f4aa&scoped=true&"
import script from "./mDevplatform.vue?vue&type=script&lang=js&"
export * from "./mDevplatform.vue?vue&type=script&lang=js&"
import style0 from "./mDevplatform.vue?vue&type=style&index=0&id=6b61f4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b61f4aa",
  null
  
)

export default component.exports